<div class="wrapper" [ngSwitch]="!!city" [class.filled]="!!city">
	<ng-container *ngSwitchCase="true">
		<span class="value">{{city.name}}</span>
		<span class="change">{{'city-search.change' | translate}}</span>
	</ng-container>

	<span class="placeholder" *ngSwitchDefault> {{'city-search.placeholder' | translate}} </span>
</div>
